<template>
  <ValidationProvider class="change-color"
                      :vid="vid"
                      :mode="mode"
                      :name="String(_uid)"
                      :rules="rules"
                      v-slot="{ errors, valid }">
    <v-text-field
      :class="customClass"
      v-model="innerValue"
      :error-messages="errors.length ? ['Je to povinné pole'] : []"
      :success="valid"
      v-bind="$attrs"
      v-on="$listeners" />
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    // must be included in props
    value: {
      type: null,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'aggressive'
    },
    vid: {
      type: String,
      default: ''
    },
  },
  data: () => ({
    innerValue: ''
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
